export const LOCATION_REDUCER_STATE_ID = 'location';
export const GLOBAL_PARAMETERS_PATH = '_global';
